import React from "react";

import type { MonitorCheckStatusExternalSilencingRule } from "../../../../../../common/openapi";

import { AppliesTo } from "./common/applies-to";
import { ExternalRuleTiming } from "./common/external-rule-timing";
import { PastRuleAlert } from "./common/past-rule-alert";
import { SilencingNote } from "./common/silencing-note";

export function ExternalPastWithoutSelector({ rule }: { rule: MonitorCheckStatusExternalSilencingRule }) {
	return (
		<div className="drawer-body flex flex-col gap-6">
			<PastRuleAlert />
			<ExternalRuleTiming rule={rule} />
			<SilencingNote note={rule.note} />
			<AppliesTo />
		</div>
	);
}
